import {
  CycleTimePipe,
  CycleTime
} from 'views/root/views/home/views/activity/views/branchesV2/cycleTimeUtil';
import { StyledCell } from '../../Table.style';
import { useContext } from 'react';
import MetricsInspectionContext from '../../../../state/context';
import { metricNames } from '@linearb/linjs-common';

const BranchMetricValueCell = ({ branch }) => {
  const {
    state: { metricName = '' }
  } = useContext(MetricsInspectionContext);

  switch (metricName) {
    case metricNames.CYCLE_TIME:
      return (
        <StyledCell data-testid='cycle-time-metric-value'>
          <CycleTime branchData={branch} />
        </StyledCell>
      );
    default:
      return (
        <StyledCell data-testid='branch-metric-value'>
          <CycleTimePipe branchData={branch} location={metricName} />
        </StyledCell>
      );
  }
};

export default BranchMetricValueCell;
